export class AuthUtils {
  static encodeToBase64(str: string): string {
    return btoa(str); // btoa converte para Base64 no navegador
  }

  static decodeFromBase64(encodedStr: string): string {
    return atob(encodedStr); // atob decodifica do Base64
  }
}